export function randomFromTo(a: number, b: number) {
  return Math.floor(Math.random() * (b - a + 1) + a);
}

export function clamp(num: number, min: number, max: number) {
  return Math.min(Math.max(num, min), max);
}
